export const content = {
  Lstg: 'Lstg.',
  emptyBadge: '-',
  missingLeistungenTooltip: 'Für dieses Produkt sind noch keine Leistung(en) durch das Produkt-Management freigegeben.',
} as const;
